import fetchApi from "@lib/api-fetcher/fetchApi";
import { API_ROUTES } from "@utils/constants";
import { reportError } from "@utils/errorReporting";

import validateCountriesResponse from "../models/countries";
import { TCountry } from "../types";
import mapCountriesResponse from "../utils/mapCountriesResponse";

type TCountriesParams = {
  countryFrom?: string;
};

const mapCountriesRequestParams = (countryFrom?: string): any => ({ countryFrom });

const loadCountries = async (
  { countryFrom }: TCountriesParams,
  locale?: string,
  hostname?: string
): Promise<TCountry[]> => {
  try {
    const response = await fetchApi({
      url: API_ROUTES.COUNTRIES,
      params: mapCountriesRequestParams(countryFrom),
      locale,
      hostname,
    });
    const countriesResponse = validateCountriesResponse(response.data);
    const filteredCountries = countriesResponse?.filter(({ code, title }) => !!code && !!title);
    return mapCountriesResponse(filteredCountries);
  } catch (err) {
    reportError(err, { module: "order" });
    return [];
  }
};
export default loadCountries;
